import React from 'react'
import { Box, Typography } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton"
import { useTranslation } from 'react-i18next'
import { useStyles } from "./styles";

export const ActionBar = () => {
  const { t } = useTranslation()
  const styles = useStyles();
  return (
    <Box className={styles.root}>
      <AddButton label={t("CATALOGS.ITEMS.ADD_ITEM")}/>
      <Box className={styles.addText}>
          {t("CATALOGS.ADD")}
      </Box>
    </Box>
  )
}
